import { EmptyState, Image, Spinner } from "@blend-ed/blendx-ui";
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import { fetchLastCompletedCourseUnit } from "@blend-ed/blendx-platform/api";
import loadingSVG from '../../../assets/loading.svg';
import RecentActivityCard from "../../../components/RecentActivityCard";
import messages from "../messages";

const RecentActivity = ({ intl }) => {
  const { data, isLoading, isError } = useReactQuery({
    queryKey: ["lastCompletedCourseUnit"],
    queryFn: fetchLastCompletedCourseUnit,
  });

  return (
    <div className="recent-activity-container">
      <div className="recent-activity__header">
        <div className="recent-activity__title">{intl.formatMessage(messages.recentActivityTitle)}</div>
        {/* <Link 
          to="#"
          className="recent-activity__link"
        >
          {intl.formatMessage(messages.seeMyFeed)}
        </Link> */}
      </div>
      {isLoading ? (
        <div className="recent-activity-loading mt-4">
          <Spinner animation="border" size="lg" variant="dark" />
        </div>
      ) : false ? (
        <RecentActivityCard
          title={data.course_title}
          type={data.activity_type}
          progressPercentage={data.completion_data.complete_percentage}
          image={data.course_image}
          link={data.resume_url}
          courseId={data.course_key}
        />
      ) : (
        <div className="recent-activity-loading">
          <EmptyState
            type="search"
            message={intl.formatMessage(messages.noRecentActivity)}
          />
        </div>
      )}
    </div>
  );
}

RecentActivity.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(RecentActivity);